module.exports = __webpack_public_path__ + "img/adinistrasi.914e2995.jpg";